export var PickingGrouping;
(function (PickingGrouping) {
    PickingGrouping[PickingGrouping["None"] = 0] = "None";
    PickingGrouping[PickingGrouping["ByStock"] = 1] = "ByStock";
})(PickingGrouping || (PickingGrouping = {}));
